export enum AgentHarnessRunStatus {
    Queued = 'queued',
    AwaitingFirstResponse = 'awaiting_first_response',
    Running = 'running',
    ActionRequired = 'action_required',
    /**
     * A workflow run paused at a wait step until `resumeAt`. Neither active nor terminal: it frees its Job lane so other runs on the
     * Job proceed, while its own workflow's later events on that Job wait for it to finish. It resumes through a queued resume.
     */
    Waiting = 'waiting',
    Completed = 'completed',
    Failed = 'failed',
    Denied = 'denied',
    Stale = 'stale',
    Cancelled = 'cancelled',
}

export const AGENT_HARNESS_ACTIVE_RUN_STATUSES = [
    AgentHarnessRunStatus.Queued,
    AgentHarnessRunStatus.AwaitingFirstResponse,
    AgentHarnessRunStatus.Running,
    AgentHarnessRunStatus.ActionRequired,
] as const;

export const AGENT_HARNESS_TERMINAL_RUN_STATUSES = [
    AgentHarnessRunStatus.Completed,
    AgentHarnessRunStatus.Failed,
    AgentHarnessRunStatus.Denied,
    AgentHarnessRunStatus.Stale,
    AgentHarnessRunStatus.Cancelled,
] as const;
